var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarInteractivelearning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.57,
    height: 13.571,
    viewBox: "0 0 13.57 13.571",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "book-world",
    d: "M13,1.856V5.095a.566.566,0,0,1-.567.565l-4.521,0a.565.565,0,0,1-.565-.565V2.65A2.262,2.262,0,0,1,9.208.424l1.5-.369A1.854,1.854,0,0,1,13,1.856ZM13.569,7.4a6.845,6.845,0,0,1-6.782,6.169h0A6.845,6.845,0,0,1,0,7.4a.565.565,0,1,1,1.126-.1,5.463,5.463,0,0,0,.244,1.182H3.339a7.044,7.044,0,0,1-.2-1.076A.565.565,0,1,1,4.268,7.3a6.031,6.031,0,0,0,.245,1.186H9.061A6.031,6.031,0,0,0,9.307,7.3a.565.565,0,1,1,1.125.11,6.976,6.976,0,0,1-.2,1.076H12.2A5.5,5.5,0,0,0,12.444,7.3a.565.565,0,1,1,1.126.1ZM5.313,12.239A11.1,11.1,0,0,1,3.719,9.613H1.881a5.755,5.755,0,0,0,3.432,2.627ZM8.608,9.613H4.965a11.039,11.039,0,0,0,1.822,2.593A11.055,11.055,0,0,0,8.608,9.613Zm3.084,0H9.853a11.108,11.108,0,0,1-1.594,2.627,5.755,5.755,0,0,0,3.432-2.627ZM5.653,5.655a.566.566,0,0,0,.565-.565V2.65A2.262,2.262,0,0,0,4.363.424L2.864.055a1.854,1.854,0,0,0-2.3,1.8V5.089a.566.566,0,0,0,.565.565H5.653Z",
    transform: "translate(-0.002 0)",
    fill: "#387F75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarInteractivelearning);
export default __webpack_public_path__ + "static/media/sidebar-interactivelearning.920247f954432a794a6984c252822458.svg";
export { ForwardRef as ReactComponent };